module.exports = __webpack_public_path__ + "static/virtual-reality-american-association-of-immunologists-da545d6f0e213b6f40ad6c6997a0d9aa.jpg";